import { AnalyticsStore } from 'bernie-plugin-mobx';
import { trackAnalytics } from 'utility/analytics';
import { ClientMetadataStore } from 'stores';

export const setPageTitle = (clientMetadataStore: ClientMetadataStore, analytics: AnalyticsStore) => {
  const { clientMetadata } = clientMetadataStore ?? {};
  const pageName = clientMetadata?.pageName;
  const pageNameAnalytics = clientMetadata?.pageNameAnalytics;

  if (pageName && pageNameAnalytics) {
    document.title = pageName;
    trackAnalytics(pageNameAnalytics, analytics);
  }
};
